<script lang="ts">
	let {
		name,
		size = 20,
		strokeWidth = 2,
		color = 'currentColor',
		class: className = '',
		filled = false,
		...restProps
	}: {
		name: string;
		size?: number;
		strokeWidth?: number;
		color?: string;
		class?: string;
		filled?: boolean;
	} = $props();
</script>

<svg
	width={size}
	height={size}
	viewBox="0 0 24 24"
	fill={filled ? color : 'none'}
	stroke={color}
	stroke-width={strokeWidth}
	stroke-linecap="round"
	stroke-linejoin="round"
	class="icon {className}"
	{...restProps}
>
	{#if name === 'zap'}
		<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
	{:else if name === 'briefcase'}
		<rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
		<path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
	{:else if name === 'trending-up'}
		<polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
		<polyline points="17 6 23 6 23 12"></polyline>
	{:else if name === 'calendar'}
		<rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
		<line x1="16" y1="2" x2="16" y2="6"></line>
		<line x1="8" y1="2" x2="8" y2="6"></line>
		<line x1="3" y1="10" x2="21" y2="10"></line>
	{:else if name === 'clock'}
		<circle cx="12" cy="12" r="10"></circle>
		<polyline points="12 6 12 12 16 14"></polyline>
	{:else if name === 'dollar-sign'}
		<line x1="12" y1="1" x2="12" y2="23"></line>
		<path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
	{:else if name === 'users'}
		<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
		<circle cx="9" cy="7" r="4"></circle>
		<path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
		<path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
	{:else if name === 'frown'}
		<circle cx="12" cy="12" r="10"></circle>
		<path d="M16 16s-1.5-2-4-2-4 2-4 2"></path>
		<line x1="9" y1="9" x2="9.01" y2="9"></line>
		<line x1="15" y1="9" x2="15.01" y2="9"></line>
	{:else if name === 'bar-chart-3'}
		<line x1="18" y1="20" x2="18" y2="10"></line>
		<line x1="12" y1="20" x2="12" y2="4"></line>
		<line x1="6" y1="20" x2="6" y2="14"></line>
	{:else if name === 'wrench'}
		<path
			d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
		></path>
	{:else if name === 'calendar-x'}
		<rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
		<line x1="16" y1="2" x2="16" y2="6"></line>
		<line x1="8" y1="2" x2="8" y2="6"></line>
		<line x1="3" y1="10" x2="21" y2="10"></line>
		<line x1="10" y1="14" x2="14" y2="18"></line>
		<line x1="14" y1="14" x2="10" y2="18"></line>
	{:else if name === 'target'}
		<circle cx="12" cy="12" r="10"></circle>
		<circle cx="12" cy="12" r="6"></circle>
		<circle cx="12" cy="12" r="2"></circle>
	{:else if name === 'refresh-cw'}
		<polyline points="23 4 23 10 17 10"></polyline>
		<polyline points="1 20 1 14 7 14"></polyline>
		<path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
	{:else if name === 'handshake'}
		<path d="m11 17 2 2a1 1 0 1 0 3-3"></path>
		<path
			d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"
		></path>
		<path d="m21 3 1 11h-2"></path>
		<path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3"></path>
		<path d="M3 4h8"></path>
	{:else if name === 'timer'}
		<line x1="10" y1="2" x2="14" y2="2"></line>
		<line x1="12" y1="14" x2="15" y2="11"></line>
		<circle cx="12" cy="14" r="8"></circle>
	{:else if name === 'sun'}
		<circle cx="12" cy="12" r="5"></circle>
		<line x1="12" y1="1" x2="12" y2="3"></line>
		<line x1="12" y1="21" x2="12" y2="23"></line>
		<line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
		<line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
		<line x1="1" y1="12" x2="3" y2="12"></line>
		<line x1="21" y1="12" x2="23" y2="12"></line>
		<line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
		<line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
	{:else if name === 'moon'}
		<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
	{:else if name === 'monitor'}
		<rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
		<line x1="8" y1="21" x2="16" y2="21"></line>
		<line x1="12" y1="17" x2="12" y2="21"></line>
	{:else if name === 'x'}
		<line x1="18" y1="6" x2="6" y2="18"></line>
		<line x1="6" y1="6" x2="18" y2="18"></line>
	{:else if name === 'globe'}
		<circle cx="12" cy="12" r="10"></circle>
		<line x1="2" y1="12" x2="22" y2="12"></line>
		<path
			d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
		></path>
	{:else if name === 'book-open'}
		<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
		<path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
	{:else if name === 'heart'}
		<path
			d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
		></path>
	{:else if name === 'umbrella-beach'}
		<path d="M6 19v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1"></path>
		<path d="M6 19l6-16 6 16"></path>
	{:else if name === 'palmtree'}
		<path d="M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h2l1-1 1 1h4"></path>
		<path d="M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-3l-1-1-1 1h-3"></path>
		<path
			d="M5.89 9.71c-2.15 2.15-2.3 5.47-.35 7.43l4.24-4.25.7-.7.71-.71 2.12-2.12c-1.95-1.96-5.27-1.8-7.42.35z"
		></path>
		<path d="M11 15.5c.5 2.5-.17 4.5-1 6.5h4c2-5.5-.5-12-1-14"></path>
	{:else if name === 'sparkles'}
		<path
			d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"
		></path>
		<path d="M5 3v4"></path>
		<path d="M19 17v4"></path>
		<path d="M3 5h4"></path>
		<path d="M17 19h4"></path>
	{:else if name === 'lock'}
		<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
		<path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
	{:else if name === 'rocket'}
		<path
			d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a1.82 1.82 0 0 0-2.91-.09z"
		></path>
		<path
			d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"
		></path>
		<path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"></path>
		<path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
	{:else if name === 'smartphone'}
		<rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
		<line x1="12" y1="18" x2="12.01" y2="18"></line>
	{:else if name === 'apple'}
		<path
			d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm3.5 6L12 11.5 8.5 8 8 8.5l3.5 3.5L8 15.5l.5.5 3.5-3.5 3.5 3.5.5-.5L12.5 12l3.5-3.5z"
		></path>
		<path d="M16.5 1.5c0 1.5-1 2.5-2.5 2.5s-2.5-1-2.5-2.5S12.5 0 14 0s2.5 0 2.5 1.5z"></path>
	{:else if name === 'play'}
		<polygon points="5 3 19 12 5 21 5 3"></polygon>
	{:else if name === 'camera'}
		<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
		></path>
		<circle cx="12" cy="13" r="4"></circle>
	{:else if name === 'bell'}
		<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
		<path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
	{:else if name === 'terminal'}
		<polyline points="4 17 10 11 4 5"></polyline>
		<line x1="12" y1="19" x2="20" y2="19"></line>
	{:else if name === 'folder'}
		<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
	{:else if name === 'file-text'}
		<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
		<polyline points="14 2 14 8 20 8"></polyline>
		<line x1="16" y1="13" x2="8" y2="13"></line>
		<line x1="16" y1="17" x2="8" y2="17"></line>
		<polyline points="10 9 9 9 8 9"></polyline>
	{:else if name === 'shield'}
		<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
	{:else if name === 'box'}
		<path
			d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
		></path>
		<polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
		<line x1="12" y1="22.08" x2="12" y2="12"></line>
	{:else if name === 'download'}
		<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
		<polyline points="7 10 12 15 17 10"></polyline>
		<line x1="12" y1="15" x2="12" y2="3"></line>
	{:else if name === 'check-circle'}
		<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
		<polyline points="22 4 12 14.01 9 11.01"></polyline>
	{:else if name === 'arrow-up-right'}
		<line x1="7" y1="17" x2="17" y2="7"></line>
		<polyline points="7 7 17 7 17 17"></polyline>
	{:else if name === 'shield-check'}
		<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
		<polyline points="9 12 12 15 17 10"></polyline>
	{:else if name === 'copy'}
		<rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
		<path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
	{:else if name === 'check'}
		<polyline points="20 6 9 17 4 12"></polyline>
	{:else if name === 'book-open'}
		<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
		<path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
	{:else if name === 'chrome'}
		<circle cx="12" cy="12" r="10"></circle>
		<circle cx="12" cy="12" r="4"></circle>
		<line x1="21.17" y1="8" x2="12" y2="8"></line>
		<line x1="3.95" y1="6.06" x2="8.54" y2="14"></line>
		<line x1="10.88" y1="21.94" x2="15.46" y2="14"></line>
	{:else if name === 'firefox'}
		<circle cx="12" cy="12" r="10"></circle>
		<path
			d="M12 2a10 10 0 0 1 7.38 16.75c.5-1.5.62-3.2.62-4.75 0-3.5-1.5-6.5-4-8.5-1.5 2-2 4.5-2 7 0 1.5.5 3 1.5 4-1.5.5-3.5.5-5 0 1-1 1.5-2.5 1.5-4 0-2.5-.5-5-2-7-2.5 2-4 5-4 8.5 0 1.55.12 3.25.62 4.75A10 10 0 0 1 12 2z"
		></path>
	{:else if name === 'safari'}
		<circle cx="12" cy="12" r="10"></circle>
		<line x1="12" y1="12" x2="12" y2="6"></line>
		<line x1="12" y1="12" x2="8" y2="16"></line>
		<polygon points="12,12 8,8 8,16 16,16 16,8"></polygon>
	{:else if name === 'edge'}
		<circle cx="12" cy="12" r="10"></circle>
		<path
			d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15h8c0 2.21-1.79 4-4 4-1.47 0-2.75-.79-3.45-1.96"
		></path>
	{:else if name === 'puzzle'}
		<path
			d="M19.439 7.85c-.049.322.059.648.289.878l1.568 1.568c.47.47.706 1.087.706 1.704s-.235 1.233-.706 1.704l-1.611 1.611a.98.98 0 0 1-.837.276c-.47-.07-.802-.48-.968-.925a2.501 2.501 0 1 0-3.214 3.214c.446.166.855.497.925.968a.979.979 0 0 1-.276.837l-1.611 1.611a2.404 2.404 0 0 1-1.704.706 2.403 2.403 0 0 1-1.704-.706l-1.568-1.568a1.026 1.026 0 0 0-.877-.29c-.493.074-.84.504-1.02.968a2.5 2.5 0 1 1-3.237-3.237c.464-.18.894-.527.968-1.02a1.026 1.026 0 0 0-.289-.877l-1.568-1.568A2.404 2.404 0 0 1 1.998 12c0-.617.236-1.234.706-1.704L4.315 8.685A.98.98 0 0 1 5.152 8.41c.47.07.802.48.968.925a2.501 2.501 0 1 0 3.214-3.214c-.446-.166-.855-.497-.925-.968a.979.979 0 0 1 .276-.837L10.296 2.705a2.404 2.404 0 0 1 1.704-.706c.617 0 1.234.236 1.704.706l1.568 1.568c.23.23.556.338.877.29.493-.074.84-.504 1.02-.968a2.5 2.5 0 1 1 3.237 3.237c-.464.18-.894.527-.968 1.02Z"
		></path>
	{:else if name === 'play-circle'}
		<circle cx="12" cy="12" r="10"></circle>
		<polygon points="10 8 16 12 10 16 10 8"></polygon>
	{:else if name === 'link-2'}
		<path d="M15 7h3a5 5 0 0 1 0 10h-3m-6 0H6a5 5 0 0 1 0-10h3"></path>
		<line x1="8" y1="12" x2="16" y2="12"></line>
	{:else if name === 'eye-off'}
		<path
			d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
		></path>
		<line x1="1" y1="1" x2="23" y2="23"></line>
	{:else if name === 'command'}
		<path
			d="M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"
		></path>
	{:else if name === 'bar-chart'}
		<line x1="12" y1="20" x2="12" y2="10"></line>
		<line x1="18" y1="20" x2="18" y2="4"></line>
		<line x1="6" y1="20" x2="6" y2="16"></line>
	{:else if name === 'link'}
		<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
		<path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
	{:else if name === 'credit-card'}
		<rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
		<line x1="1" y1="10" x2="23" y2="10"></line>
	{:else if name === 'message-square'}
		<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
	{:else if name === 'home'}
		<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
		<polyline points="9 22 9 12 15 12 15 22"></polyline>
	{:else if name === 'layers'}
		<polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
		<polyline points="2 17 12 22 22 17"></polyline>
		<polyline points="2 12 12 17 22 12"></polyline>
	{:else if name === 'building'}
		<path d="M3 21h18"></path>
		<path d="M5 21V7l8-4v18"></path>
		<path d="M19 21V11l-6-3"></path>
		<rect x="9" y="9" width="4" height="4"></rect>
		<rect x="9" y="14" width="4" height="4"></rect>
		<rect x="3" y="9" width="2" height="2"></rect>
		<rect x="3" y="14" width="2" height="2"></rect>
		<rect x="15" y="14" width="2" height="2"></rect>
	{:else if name === 'external-link'}
		<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
		<polyline points="15 3 21 3 21 9"></polyline>
		<line x1="10" y1="14" x2="21" y2="3"></line>
	{:else if name === 'user-plus'}
		<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
		<circle cx="8.5" cy="7" r="4"></circle>
		<line x1="20" y1="8" x2="20" y2="14"></line>
		<line x1="23" y1="11" x2="17" y2="11"></line>
	{:else if name === 'settings'}
		<circle cx="12" cy="12" r="3"></circle>
		<path
			d="M12 1v6m0 6v6m4.22-13.22l4.24 4.24M1.54 19.46l4.24-4.24M21 12h-6m-6 0H3m13.22 4.22l4.24 4.24M1.54 4.54l4.24 4.24"
		></path>
	{:else if name === 'folder-plus'}
		<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
		<line x1="12" y1="11" x2="12" y2="17"></line>
		<line x1="9" y1="14" x2="15" y2="14"></line>
	{:else if name === 'user'}
		<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
		<circle cx="12" cy="7" r="4"></circle>
	{:else if name === 'arrow-right'}
		<line x1="5" y1="12" x2="19" y2="12"></line>
		<polyline points="12 5 19 12 12 19"></polyline>
	{:else if name === 'arrow-left'}
		<line x1="19" y1="12" x2="5" y2="12"></line>
		<polyline points="12 19 5 12 12 5"></polyline>
	{:else if name === 'chevron-left'}
		<polyline points="15 18 9 12 15 6"></polyline>
	{:else if name === 'chevron-right'}
		<polyline points="9 18 15 12 9 6"></polyline>
	{:else if name === 'chevrons-left'}
		<polyline points="11 17 6 12 11 7"></polyline>
		<polyline points="18 17 13 12 18 7"></polyline>
	{:else if name === 'chevrons-right'}
		<polyline points="13 17 18 12 13 7"></polyline>
		<polyline points="6 17 11 12 6 7"></polyline>
	{:else if name === 'help-circle'}
		<circle cx="12" cy="12" r="10"></circle>
		<path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
		<line x1="12" y1="17" x2="12.01" y2="17"></line>
	{:else if name === 'life-buoy'}
		<circle cx="12" cy="12" r="10"></circle>
		<circle cx="12" cy="12" r="4"></circle>
		<line x1="4.93" y1="4.93" x2="9.17" y2="9.17"></line>
		<line x1="14.83" y1="14.83" x2="19.07" y2="19.07"></line>
		<line x1="14.83" y1="9.17" x2="19.07" y2="4.93"></line>
		<line x1="14.83" y1="9.17" x2="18.36" y2="5.64"></line>
		<line x1="4.93" y1="19.07" x2="9.17" y2="14.83"></line>
	{:else if name === 'linkedin'}
		<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
		<rect x="2" y="9" width="4" height="12"></rect>
		<circle cx="4" cy="4" r="2"></circle>
	{:else if name === 'check-square'}
		<polyline points="9 11 12 14 22 4"></polyline>
		<path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
	{:else if name === 'user-check'}
		<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
		<circle cx="8.5" cy="7" r="4"></circle>
		<polyline points="17 11 19 13 23 9"></polyline>
	{:else if name === 'archive'}
		<polyline points="21 8 21 21 3 21 3 8"></polyline>
		<rect x="1" y="3" width="22" height="5"></rect>
		<line x1="10" y1="12" x2="14" y2="12"></line>
	{:else if name === 'folder-open'}
		<path
			d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"
		></path>
	{:else if name === 'type'}
		<polyline points="4 7 4 4 20 4 20 7"></polyline>
		<line x1="9" y1="20" x2="15" y2="20"></line>
		<line x1="12" y1="4" x2="12" y2="20"></line>
	{:else if name === 'paperclip'}
		<path
			d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48"
		></path>
	{:else if name === 'file'}
		<path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
		<polyline points="13 2 13 9 20 9"></polyline>
	{:else if name === 'share-2'}
		<circle cx="18" cy="5" r="3"></circle>
		<circle cx="6" cy="12" r="3"></circle>
		<circle cx="18" cy="19" r="3"></circle>
		<line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
		<line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
	{:else if name === 'send'}
		<line x1="22" y1="2" x2="11" y2="13"></line>
		<polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
	{:else if name === 'bar-chart-2'}
		<line x1="18" y1="20" x2="18" y2="10"></line>
		<line x1="12" y1="20" x2="12" y2="4"></line>
		<line x1="6" y1="20" x2="6" y2="14"></line>
	{:else if name === 'move'}
		<polyline points="5 9 2 12 5 15"></polyline>
		<polyline points="9 5 12 2 15 5"></polyline>
		<polyline points="15 19 12 22 9 19"></polyline>
		<polyline points="19 9 22 12 19 15"></polyline>
		<line x1="2" y1="12" x2="22" y2="12"></line>
		<line x1="12" y1="2" x2="12" y2="22"></line>
	{:else if name === 'sliders'}
		<line x1="4" y1="21" x2="4" y2="14"></line>
		<line x1="4" y1="10" x2="4" y2="3"></line>
		<line x1="12" y1="21" x2="12" y2="12"></line>
		<line x1="12" y1="8" x2="12" y2="3"></line>
		<line x1="20" y1="21" x2="20" y2="16"></line>
		<line x1="20" y1="12" x2="20" y2="3"></line>
		<line x1="1" y1="14" x2="7" y2="14"></line>
		<line x1="9" y1="8" x2="15" y2="8"></line>
		<line x1="17" y1="16" x2="23" y2="16"></line>
	{/if}
</svg>

<style>
	:global(.icon) {
		flex-shrink: 0;
		transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	}

	:global(.icon--spin) {
		animation: spin 1s linear infinite;
	}

	:global(.icon--pulse) {
		animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
	}

	:global(.icon--bounce) {
		animation: bounce 1s infinite;
	}

	@keyframes spin {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}

	@keyframes pulse {
		0%,
		100% {
			opacity: 1;
		}
		50% {
			opacity: 0.5;
		}
	}

	@keyframes bounce {
		0%,
		100% {
			transform: translateY(-25%);
			animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
		}
		50% {
			transform: translateY(0);
			animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
		}
	}
</style>
